import ContactBlock from '../components/ContactBlock';
import HoursTable from '../components/HoursTable';
import { OrnateDivider, BananaLeaf } from '../components/KeralaDecor';
import { useWhatsApp } from '../context/WhatsAppContext';
import site from '../data/site';
import './ContactPage.css';

export default function ContactPage() {
  const { open } = useWhatsApp();

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <BananaLeaf position="top-left" size={240} opacity={0.4} />
        <BananaLeaf position="top-right" size={240} opacity={0.4} mirror />
        <div className="container contact-hero__inner">
          <span className="eyebrow-script">We'd love to feed you</span>
          <h1 className="contact-hero__title">Visit Us in Frisco</h1>
          <OrnateDivider />
          <p className="contact-hero__lead">
            We're on Preston Road. Walk in, call ahead, or message us. We're happy to take special requests.
          </p>
        </div>
      </section>

      <section className="contact-body">
        <div className="container contact-grid">
          <div className="contact-grid__left">
            <ContactBlock variant="light" />
            <div className="contact-cta">
              <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-gold">
                Get Directions
              </a>
              <button onClick={open} className="btn btn-whatsapp">📱 Join WhatsApp</button>
            </div>
          </div>

          <div className="contact-grid__right">
            <iframe
              src={site.address.embedUrl}
              width="100%"
              height="420"
              style={{ border: 0, borderRadius: 'var(--radius-md)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`H2 Fresh Location Map - ${site.address.full}`}
            ></iframe>
          </div>
        </div>

        <div className="container contact-hours">
          <HoursTable />
        </div>
      </section>
    </main>
  );
}
